/**
 * PrivateRoute Component - Protected route wrapper
 */

import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@hooks/useAuth';
import Loader from '@components/common/Loader';
import { getActingWedding } from '@utils/actingWedding';

const PrivateRoute = ({ children, roles = [], allowActingPlanner = false }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  // Show loader while checking auth
  if (isLoading) {
    return (
      <div className="page-loader">
        <Loader size="lg" />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // A planner may use the couple dashboard only while working inside a
  // client wedding in this tab; the API checks the assignment itself.
  const actingPlanner = allowActingPlanner && user?.role === 'coordinator' && !!getActingWedding();

  // Check role authorization
  if (roles.length > 0 && user && !roles.includes(user.role) && !actingPlanner) {
    // Redirect based on user role
    const redirectMap = {
      vendor: '/vendor',
      admin: '/admin',
      super_admin: '/admin',
      venue_owner: '/venue',
      coordinator: '/coordinator',
      guest: '/guest',
    };
    const redirectPath = redirectMap[user.role] || '/dashboard';
    return <Navigate to={redirectPath} replace />;
  }

  return children;
};

export default PrivateRoute;
